module.exports = __webpack_public_path__ + "logo-d0443db817cde5cd3a42960742b0e3a2.png";